module.exports = __webpack_public_path__ + "img/pa.a5a80e3e.svg";